/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { authAPI } from '../../services/api';

export default function VerifyEmail() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || '';
  const navigate = useNavigate();

  const [state, setState] = useState('loading'); // loading | success | error
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (!token) { setState('error'); setMessage('No verification token found in this link.'); return; }
    authAPI.verifyEmail(token)
      .then(data => { setState('success'); setMessage(data.message || 'Email verified successfully.'); })
      .catch(err => { setState('error'); setMessage(err?.error || 'This link is invalid or has expired.'); });
  }, [token]);

  return (
    <div className="login-container">
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%', maxWidth: '420px' }}>
        <div className="login-card" style={{ width: '100%', textAlign: 'center' }}>
          <div className="login-logo">
            <img src="/casavello-stacked.png" alt="casavello" style={{ width: '140px', height: 'auto', objectFit: 'contain', marginBottom: '0.5rem' }} />
          </div>

          {state === 'loading' && (
            <div style={{ padding: '1rem 0' }}>
              <div style={{ fontSize: '2.5rem', marginBottom: '1rem' }}>⏳</div>
              <p style={{ color: 'var(--text-secondary)' }}>Verifying your email…</p>
            </div>
          )}

          {state === 'success' && (
            <div style={{ padding: '1rem 0' }}>
              <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>✅</div>
              <h2 style={{ color: 'var(--brand-green)', marginBottom: '0.5rem' }}>Email Verified</h2>
              <p style={{ color: 'var(--text-secondary)', marginBottom: '1.5rem', lineHeight: 1.6 }}>{message}</p>
              <button className="btn btn-success" style={{ width: '100%', padding: '0.875rem', fontSize: '1rem' }} onClick={() => navigate('/')}>
                Go to Dashboard →
              </button>
            </div>
          )}

          {state === 'error' && (
            <div style={{ padding: '1rem 0' }}>
              <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>⚠️</div>
              <h2 style={{ color: '#ef4444', marginBottom: '0.5rem' }}>Verification Failed</h2>
              <p style={{ color: 'var(--text-secondary)', marginBottom: '1.5rem', lineHeight: 1.6 }}>{message}</p>
              <button className="btn btn-primary" style={{ width: '100%', padding: '0.875rem', fontSize: '1rem' }} onClick={() => navigate('/login')}>
                Back to Login
              </button>
              <p style={{ color: 'var(--text-secondary)', fontSize: '0.8rem', marginTop: '1rem' }}>
                Once logged in, you can request a new verification link from the banner at the top of the page.
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
